module.exports = __webpack_public_path__ + "static/media/panico.548659a9.png";